// import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import Header from 'components/total-eclipse/Header'

import { Root, Main, Body } from './Text.style'

const Text = ({ header, children }) => {
  return (
    <Fade duration={1500}>
      <Root>
        <Main>
          <Header className="mb-4">{header}</Header>
          <Body>{children}</Body>
        </Main>
      </Root>
    </Fade>
  )
}

Text.propTypes = {}

Text.defaultProps = {}

export default Text
